import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import {
  Outlet, useNavigate,
} from 'react-router-dom';
import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext } from './Context';

export default function Main({ programId }) {
  const { dispatch, actions, state } = useContext();
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const navigate = useNavigate();

  useEffect(() => {
    actions.load(dispatch, programId);
  }, []);

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      navigate(1); // Moves forward in history to prevent going back
      Alert({
        text: 'Please complete each step in sequence. This helps us set up your account properly.',
      });
    };

    window.onpopstate = handleBackButton;

    return () => {
      window.onpopstate = null;
    };
  }, [navigate]);

  useEffect(() => {
    if (state.isSecondProgramOnboarding && state.workflow === 'PROGRAM_ONBOARDING') {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    } else if (state.isFirstOnboarding !== null) {
      if (state.workflow === 'RETURN_TO_WORK_ONBOARDING') {
        navigate(routes.members.onboarding.welcomeRTW);
      } else if (state.isFirstOnboarding) {
        if (state.workflow === 'CPA_PROGRAM_ONBOARDING') {
          navigate(routes.members.onboarding.welcomeCpa);
        } else {
          navigate(routes.members.onboarding.welcome);
        }
      } else if (state.workflow === 'CPA_PROGRAM_ONBOARDING') {
        navigate(routes.members.onboarding.welcomeCpa);
      } else {
        navigate(routes.members.onboarding.continue);
      }
    }
  }, [state.isFirstOnboarding]);

  useEffect(() => {
    if (state.currentStep !== null && state.currentStep > 0) {
      const currentStep = state.steps[state.currentStep];
      const url = actions.getStepRoute(currentStep, state.programId);
      if (url) {
        navigate(url);
      }
    }
  }, [state.currentStep]);

  if (state.steps === null) {
    return (
      <div className="content onboarding-content p-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return (
    <div>
      <Outlet />
    </div>
  );
}

Main.propTypes = {
  programId: PropTypes.number,
};

Main.defaultProps = {
  programId: null,
};
